import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";
import { ScrollToTopOnMount } from "frame/components";
import { SiteForm, SiteListing } from "features/sites";
import { useRouter, isNotNullOrEmpty, useTerminology } from "utils";

const useStyles = makeStyles((theme) => ({
	root: {},
	container: {
		margin: theme.spacing(4, 3),
	},
	embeddedContainer: {
		margin: theme.spacing(1, 2, 2, 2),
	},
	content: {
		position: "relative",
		paddingBottom: theme.spacing(6),
		backgroundColor: theme.palette.white,
		overflowX: "hidden",
	},
	embeddedContent: {
		paddingBottom: theme.spacing(2),
	},
	list: {
		marginTop: theme.spacing(2),
	},
}));

const Sites = ({
	siteList = [],
	role,
	onEdit,
	onDelete,
	onSelectSite,
	variant = "page",
	customerId: customerIdProp,
}) => {
	const classes = useStyles();
	const { sitesLabel } = useTerminology();
	const { match } = useRouter();
	const customerId = customerIdProp || match?.params?.customerId;
	const isEmbedded = variant === "embedded";

	const customerFilteredSiteList =
		siteList && siteList.filter((site) => site.customerId === customerId);

	const empty =
		customerFilteredSiteList && customerFilteredSiteList.length <= 0;

	const content = (
		<>
			<SiteForm />
			<div className={isEmbedded ? classes.embeddedContainer : classes.container}>
				{!isEmbedded && (
					<Typography variant="h2">{sitesLabel}</Typography>
				)}
				<div className={classes.list}>
					{!empty &&
						isNotNullOrEmpty(customerFilteredSiteList) &&
						customerFilteredSiteList.map((node, index) => (
							<SiteListing
								key={node.id || index}
								site={node}
								role={role}
								onEdit={onEdit}
								onDelete={onDelete}
								onSelectSite={onSelectSite}
							/>
						))}
				</div>

				{empty && (
					<Typography variant="body1">
						There are currently no sites listed for this customer.
					</Typography>
				)}
			</div>
		</>
	);

	if (isEmbedded) {
		return (
			<div className={classes.embeddedContent}>
				<ScrollToTopOnMount />
				{content}
			</div>
		);
	}

	return (
		<div className={classes.content}>
			<ScrollToTopOnMount />
			{content}
		</div>
	);
};

Sites.propTypes = {
	siteList: PropTypes.array,
	role: PropTypes.string.isRequired,
	onEdit: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired,
	onSelectSite: PropTypes.func.isRequired,
	variant: PropTypes.oneOf(["page", "embedded"]),
	customerId: PropTypes.string,
};

export default Sites;
